import { analyticsUtils } from 'utils';

export const sendPhoneGA = (phone?: string, name?: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'shopPage',
    elementText: `${phone} / ${name}`, // номер телефона / магазин
    elementName: 'list', // название блока
  });
};

export const sendInfobarShowGA = (name?: string, title?: string) => {
  analyticsUtils.sendEvent('GA:show', {
    elementType: 'block',
    elementBlock: 'shopPage',
    elementText: `${name} / ${title}`, // номер телефона / магазин
    elementName: 'list', // название блока
  });
};

export const sendInfobarHintShowGA = (name?: string, title?: string) => {
  analyticsUtils.sendEvent('GA:show', {
    elementType: 'block',
    elementBlock: 'shopPage',
    elementText: `Подсказка / ${name} / ${title}`, // номер телефона / магазин
    elementName: 'list', // название блока
  });
};

export const sendStorePageButtonGA = (text: string, name?: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'shopPage',
    elementText: `${text} / ${name}`, // Название кнопки / название магазина
    elementName: 'list', // название блока
  });
};
